import { render, staticRenderFns } from "@/manager/convocation/views/convocationDetail/participantList/participantList.pug?vue&type=template&id=20bfb76b&scoped=true&lang=pug&external"
import script from "./participantList.view.vue?vue&type=script&lang=ts"
export * from "./participantList.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/convocation/views/convocationDetail/participantList/participantList.scss?vue&type=style&index=0&id=20bfb76b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bfb76b",
  null
  
)

export default component.exports